import React, { Component } from 'react';
import { DFPAdvert } from './DFPAdvert';
import {DFP_SIZES} from "./ReactDFPHelper";

class DFPDynamicBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            windowWidth: window.innerWidth,
        };
    }

    componentDidMount = () => {
        window.addEventListener('resize', this.updateWindowWidth);
    };

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.updateWindowWidth);
    };

    updateWindowWidth = () => {
        return this.setState({
            windowWidth: window.innerWidth,
        });
    };

    render() {
        //To guarantee iPad + higher can see ads, not mobile.
        return this.state.windowWidth <= 767 ? null : <DFPAdvert sizes={DFP_SIZES.Banner} />
    }
}

export default DFPDynamicBanner;



// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/DFPDynamicBanner.js